'use client'

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';

// lib files
import { normalizeTextInput } from '@/lib/helpers/normalize-text-input';
import { showsFiltersAtom } from '@/lib/atoms/shows-filters';

// svgs
import SearchIcon from '@/public/svg/search.svg';
import CloseIcon from '@/public/svg/pbs-close-white.svg';

// styles
import styles from '@/app/(main)/shows/ShowsLandingFilters/TitleSearch.module.scss';

function MobileFilters() {
  const [showsFilters, setShowsFilters] = useAtom(showsFiltersAtom)
  const [debouncedTextInput, setDebouncedTextInput] = useState(showsFilters.search)

  useEffect(() => {
    const normalizedTextInput = normalizeTextInput(debouncedTextInput || '');

    if(normalizedTextInput === showsFilters.search) {
      return
    }

    const handler = setTimeout(() => {
      setShowsFilters(previousFilters => {
        return { ...previousFilters, search: normalizedTextInput }
      })
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  // Only run this useEffect when deboucedTextInput changes otherwise the timeout
  // can get cleared prematurely.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedTextInput])

  return (
    <div className={styles.text_input}>
      <label className={styles.legend} htmlFor='shows_landing__filter_by_title'>
        Filter by Title:
      </label>

      {debouncedTextInput?.length !== 0 && (
        <CloseIcon
          className={`${styles.text_input_icon} ${styles.text_input_icon_close}`}
          aria-label='Clear text input button'
          onClick={() => setDebouncedTextInput('')}
        />
      )}

      <input
        type='text'
        id='shows_landing__filter_by_title'
        className={styles.title_filter_input}
        value={debouncedTextInput}
        onChange={(e) => setDebouncedTextInput(e.target.value)}
        placeholder='Search By Show Title'
      />

      {debouncedTextInput?.length === 0 && (
        <SearchIcon className={styles.text_input_icon} />
      )}
  </div>
  )
}


export default MobileFilters
